module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navbar'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    staticClass: "view"
  })], 1), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "50px",
      "background": "red",
      "color": "#fff"
    }
  }, [_c('h1', [_vm._v("This website is no longer updated."), _c('br'), _c('br'), _vm._v("Please go to to the new ICJIA GATA website:"), _c('br'), _c('br'), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud"
    }
  }, [_vm._v("https://grants.icjia.cloud")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 368
// module chunks = 0